export const COMMENTS_PATH_NAME = 'comments';
